import gql from "graphql-tag";

export const GetProfileInfo = gql`
  query getProfileInfo {
    accounts {
      id
      email
      name
      username
      pocName
      picture
    }
  }
`;
